function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*
 * Website Analytics › key values recorded on a conversion / interaction (the legacy
 * "Interaction Details" page). Data: /metrics/keyvalues/{type}/{name}/{start}/{end} →
 * {result[{keyName, keyValue, name}]}; keyValue is usually a JSON payload, which the
 * shared activity-key-values helper pivots into one row per event with a column per key.
 * Filters: any column ≥/contains, a column picker for wide payloads, CSV export.
 */
import React from "react";
import { Link, withRouter } from "react-router-dom";
import { Pending } from "../../components/analytics-kit";
import PlunkDropDown from "../../components/plunk-dropdown";
import { num, rangeLabelFor, RANGES } from "../sales/territory-common";
import ServiceFactory from "../../service";
import Auth from "../../functions/authenticate";
import activityKeyValues from "../../functions/activity-key-values";
import csv from "../../functions/csv";
import { safe } from "./data";
import { fmtD } from "./header";
const PAGE = 50;
class ActivityKeyValues extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      ready: false,
      data: undefined,
      q: "",
      col: "",
      page: 0,
      showAll: false
    });
  }
  async componentDidMount() {
    if (Auth.isAuthenticated() || (await Auth.attachOrSignIn())) this.setState({
      ready: true
    }, () => this.load());
  }
  async load() {
    const {
      type,
      name,
      startDate,
      endDate
    } = this.props.params;
    this.setState({
      data: undefined
    });
    const S = ServiceFactory.getType(`/metrics/keyvalues/${type}/${name}/${startDate}/${endDate}`);
    const r = await safe(new S().getAsync());
    const list = r && r.data && Array.isArray(r.data.result) ? r.data.result : r && Array.isArray(r.result) ? r.result : Array.isArray(r) ? r : [];
    let parsed = null;
    try {
      parsed = list.length ? activityKeyValues.parse(list) : {
        rows: [],
        columns: [],
        columnDisplay: {}
      };
    } catch (e) {
      parsed = {
        rows: [],
        columns: [],
        columnDisplay: {}
      };
    }
    this.setState({
      data: parsed,
      page: 0
    });
  }
  export() {
    const {
      data
    } = this.state;
    const {
      name,
      startDate,
      endDate
    } = this.props.params;
    if (!data || !data.rows.length) return;
    const text = csv.generate(this.filtered(), data.columns);
    const blob = new Blob([text], {
      type: "text/csv"
    });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `${String(name).replace(/@/g, "-")}-keyvalues-${startDate}-${endDate}.csv`;
    document.body.appendChild(a);
    a.click();
    a.remove();
  }
  filtered() {
    const {
      data,
      q,
      col
    } = this.state;
    if (!data) return [];
    const needle = q.trim().toLowerCase();
    if (!needle) return data.rows;
    return data.rows.filter(r => {
      const hay = col ? [r[col]] : Object.values(r);
      return hay.some(v => String(v == null ? "" : v).toLowerCase().includes(needle));
    });
  }
  render() {
    const {
      type,
      name,
      startDate,
      endDate
    } = this.props.params;
    const {
      ready,
      data,
      q,
      col,
      page,
      showAll
    } = this.state;
    if (!ready) return null;
    const isConv = !/engage|interact/i.test(type || "");
    const label = isConv ? "Conversion" : "Interaction";
    const displayName = String(name || "").replace(/@/g, " ");
    const rows = this.filtered();
    const cols = data ? data.columns.filter(c => showAll || data.columnDisplay[c.prop] !== false) : [];
    const hidden = data ? data.columns.length - cols.length : 0;
    const pages = Math.max(1, Math.ceil(rows.length / PAGE));
    const slice = rows.slice(page * PAGE, page * PAGE + PAGE);
    return /*#__PURE__*/React.createElement("div", {
      className: "territory-view wa-view"
    }, /*#__PURE__*/React.createElement("header", {
      className: "wa-hdr"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "wa-crumbs"
    }, /*#__PURE__*/React.createElement(Link, {
      to: "/Activity"
    }, "Website Analytics"), " \xB7 ", /*#__PURE__*/React.createElement(Link, {
      to: "/Activity/acquisition"
    }, "Acquisition"), " \xB7 ", /*#__PURE__*/React.createElement(Link, {
      to: `/Activity/Detail/${type}/${name}/this_month`
    }, displayName), " \xB7 Key values"), /*#__PURE__*/React.createElement("h1", null, displayName, " ", /*#__PURE__*/React.createElement("span", {
      className: "wa-chip"
    }, /*#__PURE__*/React.createElement("span", {
      className: "k"
    }, label, " details"))), /*#__PURE__*/React.createElement("div", {
      className: "sub"
    }, `${fmtD(startDate)} – ${fmtD(endDate)}`)), /*#__PURE__*/React.createElement("a", {
      className: "wa-chip",
      href: "#",
      style: {
        marginLeft: "auto"
      },
      onClick: e => {
        e.preventDefault();
        this.export();
      }
    }, "Export CSV")), data === undefined ? /*#__PURE__*/React.createElement("div", {
      className: "wa-ribbon"
    }, /*#__PURE__*/React.createElement(Pending, {
      h: 90
    })) : /*#__PURE__*/React.createElement("div", {
      className: "wa-ribbon four"
    }, [["Events with key values", num(data.rows.length)], ["Keys", num(data.columns.length)], ["Matching", num(rows.length)], ["Window", `${fmtD(startDate)} – ${fmtD(endDate)}`]].map(([l, v]) => /*#__PURE__*/React.createElement("div", {
      className: "wa-kpi",
      key: l
    }, /*#__PURE__*/React.createElement("div", {
      className: "l"
    }, l), /*#__PURE__*/React.createElement("div", {
      className: "v"
    }, v)))), /*#__PURE__*/React.createElement("div", {
      className: "wa-grid"
    }, /*#__PURE__*/React.createElement("section", {
      className: "wa-card"
    }, /*#__PURE__*/React.createElement("h2", null, "Key values", /*#__PURE__*/React.createElement("span", {
      className: "hint"
    }, "one row per event \xB7 a column per key")), /*#__PURE__*/React.createElement("div", {
      className: "wa-toolbar"
    }, /*#__PURE__*/React.createElement("span", {
      className: "wa-filters"
    }, data && data.columns.length > 1 ? /*#__PURE__*/React.createElement(PlunkDropDown, {
      options: [["", "Any column"]].concat(data.columns.map(c => [c.prop, c.title])),
      value: col,
      onChange: v => this.setState({
        col: v,
        page: 0
      }),
      width: "180px"
    }) : null, /*#__PURE__*/React.createElement("input", {
      className: "cust-search wa-search",
      type: "search",
      value: q,
      placeholder: col ? "Contains…" : "Search all columns",
      onChange: e => this.setState({
        q: e.target.value,
        page: 0
      })
    }), hidden > 0 || showAll ? /*#__PURE__*/React.createElement("button", {
      className: "wa-chip",
      onClick: () => this.setState({
        showAll: !showAll
      })
    }, showAll ? "Fewer columns" : `+${hidden} more columns`) : null, q ? /*#__PURE__*/React.createElement("button", {
      className: "wa-chip",
      onClick: () => this.setState({
        q: "",
        col: "",
        page: 0
      })
    }, "Clear") : null)), data === undefined ? /*#__PURE__*/React.createElement(Pending, null) : !data.rows.length ? /*#__PURE__*/React.createElement("div", {
      className: "wa-empty"
    }, "No key values were sent with this ", label.toLowerCase(), " in this window. The tracker records them when the event carries key/value pairs.") : !rows.length ? /*#__PURE__*/React.createElement("div", {
      className: "wa-empty"
    }, "No rows match.") : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "tblwrap"
    }, /*#__PURE__*/React.createElement("table", {
      className: "territory-table wa-table"
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, cols.map(c => /*#__PURE__*/React.createElement("th", {
      key: c.prop
    }, c.title)))), /*#__PURE__*/React.createElement("tbody", null, slice.map((r, i) => /*#__PURE__*/React.createElement("tr", {
      key: i
    }, cols.map(c => /*#__PURE__*/React.createElement("td", {
      key: c.prop,
      title: String(r[c.prop] == null ? "" : r[c.prop])
    }, String(r[c.prop] == null ? "" : r[c.prop]).slice(0, 80)))))))), pages > 1 ? /*#__PURE__*/React.createElement("div", {
      className: "wa-toolbar",
      style: {
        marginTop: 10
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "seg"
    }, /*#__PURE__*/React.createElement("button", {
      disabled: page === 0,
      onClick: () => this.setState({
        page: page - 1
      })
    }, "\u2039 Prev"), /*#__PURE__*/React.createElement("button", {
      className: "on"
    }, page + 1, " / ", pages), /*#__PURE__*/React.createElement("button", {
      disabled: page >= pages - 1,
      onClick: () => this.setState({
        page: page + 1
      })
    }, "Next \u203A")), /*#__PURE__*/React.createElement("span", {
      className: "wa-hint",
      style: {
        fontSize: 12,
        color: "var(--plk-text-subtle)"
      }
    }, num(rows.length), " rows \xB7 50 per page")) : null))));
  }
}
export default withRouter(ActivityKeyValues);